import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { Extraction } from "../../../api/knowledgeData/knowledgeDataDecoders";
import { proposalPath } from "./proposalPath";
import { formatTimeAgo } from "../../../shared/formatting/relativeTimes";
import { namedPerson } from "../../threads/data/namedPerson";
import { useMemberNames } from "../../threads/data/useMemberNames";

export default function LineageNotice({ extraction }: { extraction: Extraction }) {
  const { t, i18n } = useTranslation();
  const people = useMemberNames(extraction.projectId);
  return <div className="space-y-1 text-sm">
    {extraction.state === "proposed" && extraction.workingStateOf !== null
      ? <p>{t("data.lineage.workingState", namedPerson(people, extraction.workingStateOf))}</p> : null}
    {extraction.lineage.pending.map((proposal) => <p key={proposal.source}>
      <Link className="app-link" to={proposalPath(proposal.source)}>
        {t(proposal.newer ? "data.lineage.newer" : "data.lineage.pending", { ...namedPerson(people, proposal.by), time: formatTimeAgo(proposal.recordedAt, i18n.resolvedLanguage) })}
      </Link>
    </p>)}
    {extraction.superseded.length > 0 ? <p>{t("data.lineage.closed")}{" "}{extraction.superseded.map((source) => <Link key={source} className="app-link mr-2" to={proposalPath(source)}>{source}</Link>)}</p> : null}
    {extraction.skipped.length > 0 ? <p>{t("data.lineage.skipped", { sources: extraction.skipped.join(", ") })}</p> : null}
  </div>;
}
